import React, { useState, useEffect } from 'react';
import Accordion from '@/Components/Accordion/Accordion';
// import { Helmet } from "react-helmet";

import { FaqContent } from '../Data/faqData';
import Head from 'next/head';
import MainHeading from '@/Components/MainHeading';

export default function Faq() {
  const [searchText, setSearchText] = useState('');
  const [faqContent, setFaqContent] = useState(FaqContent);

  useEffect(() => {
    if (searchText && searchText === '') {
      setFaqContent(FaqContent);
    } else {
      let modifiedFaqContent = [];
      FaqContent.forEach((faq, i) => {
        if (faq.title.toLowerCase().includes(searchText.toLowerCase())) {
          modifiedFaqContent.push(faq);
        }
      });
      setFaqContent(modifiedFaqContent);
    }
  }, [searchText]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0c9611"></meta>
        <meta name="faq" content="All your questions related to fyllo is here ."></meta>
        <link rel="icon" sizes="192x192" href="../../public/fyllo.svg"></link>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@site_account" />
        <meta name="twitter:creator" content="@fylloTech" />
        <meta name="twitter:url" content="https://twitter.com/fyllotech?lang=en" />
        <meta name="twitter:title" content="FAQ : Fyllo by AgriHawk Technologies" />
        <link rel="manifest" href="/site.webmanifest" />
        <meta
          name="twitter:description"
          content="Fyllo is a next gen agriculture technology company that hepling farmer with precision farming "
        />
        <meta
          name="twitter:image"
          content="https://pbs.twimg.com/profile_images/1522497408298487809/kGdMr3VG_400x400.jpg"
        />
        <meta
          name="twitter:image:alt"
          content="A text description of the image conveying the essential nature of an image to users who are visually impaired. Maximum 420 characters."
        ></meta>
        <title>FAQ</title>
      </Head>
      <MainHeading text=" Frequently Asked Questions" />

      <form className="p-4 md:px-20 flex justify-center">
        <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only ">
          Search
        </label>
        <div className="relative md:w-1/3  ">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg
              aria-hidden="true"
              className="w-5 h-5 text-gray-500 "
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </div>
          {/* <input
           onChange={(e) => {
            setSearchText(e.target.value);
          }}
           type="text" placeholder="Type here" className="pl-10 input input-bordered input-fyllo-800 w-full max-w-xs accent-fyllo-800" /> */}
          <input
            style={{}}
            placeholder="Search for Question..."
            type="search"
            id="default-search"
            className="appearance-none input accent-fyllo-800 block w-full self-center pl-10 text-gray-900 border-0  bg-white border-b-2 border-gray-300 hover:border-transparent active:border-transparent focus:border-transparent "
            required
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </div>
      </form>

      <div className="flex flex-col gap-2 h-full p-0 py-10 md:p-10">
        <Accordion AccordionItems={faqContent} isContentComponent={true} />
      </div>
    </div>
  );
}
